import firebase from "firebase";

export class AuthStatus {
    static UNKNOWN = 0;
    static AUTHORIZED = 1;
    static UNAUTHORIZED = 2;
}

export default {
    namespaced: true,
    state: {
        mAuthStatus: AuthStatus.UNKNOWN
    },
    getters: {
        getAuthStatus: state => {
            return state.mAuthStatus;
        },

        isAuthorized: state => {
            return state.mAuthStatus == AuthStatus.AUTHORIZED;
        }
    },
    mutations: {
        setAuthStatus(state, status) {
            state.mAuthStatus = status;
        }
    },
    actions: {
        init({commit}) {
            let auth = firebase.auth()
            console.warn("AUTH :: init");
            commit("setAuthStatus", AuthStatus.UNKNOWN);
            auth.onAuthStateChanged((user) => {
                console.warn("AUTH:: onAuthStateChanged, user: ", user == null);
                if (user !== null) {
                    commit("setAuthStatus", AuthStatus.AUTHORIZED);
                } else {
                    commit("setAuthStatus", AuthStatus.UNAUTHORIZED);
                }
            });
        },

        signIn({commit}, data) {
            commit("setAuthStatus", AuthStatus.UNAUTHORIZED);
            commit('setLoading', true, {root: true});
            commit('setError', null, {root: true});

            if (data.provider === "email") {
                if (!data.username || !data.password) {
                    commit('setError', "Auth failed", {root: true});
                    commit("setLoading", false, {root: true});
                    return Promise.reject("Invalid user or password");
                } else {
                    let auth = firebase.auth();

                    return auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
                        .then(() => {
                            return auth.signInWithEmailAndPassword(data.username, data.password);
                        })
                        .then((result) => {
                            if (result && result.user) {
                                commit("setAuthStatus", AuthStatus.AUTHORIZED);
                            } else {
                                commit("setAuthStatus", AuthStatus.UNAUTHORIZED)
                            }
                            return Promise.resolve();
                        })
                        .catch((error) => {
                            commit('setError', error.message, {root: true});
                            return Promise.reject(error.message);
                        })
                        .finally(() => {
                            commit("setLoading", false, {root: true});
                        });
                }
            } else {
                commit('setError', "Auth failed", {root: true});
                commit("setLoading", false, {root: true});
                return Promise.reject("unknown provider");
            }
        },

        signInWithGoogle({commit}, { credential }) {
            commit("setAuthStatus", AuthStatus.UNAUTHORIZED);
            commit('setLoading', true, {root: true});
            commit('setError', null, {root: true});
            if (!credential) {
                commit('setError', "No Google credential provided", {root: true});
                commit("setLoading", false, {root: true});
                return Promise.reject("No Google credential provided");
            }
            const googleCredential = firebase.auth.GoogleAuthProvider.credential(credential);
            let auth = firebase.auth();
            return auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
                .then(() => {
                    return auth.signInWithCredential(googleCredential);
                })
                .then((result) => {
                    commit("setAuthStatus", AuthStatus.AUTHORIZED);
                    commit("setLoading", false, {root: true});
                    return result;
                })
                .catch((error) => {
                    commit('setError', error.message, {root: true});
                    commit("setLoading", false, {root: true});
                    return Promise.reject(error);
                });
        },

        signOut({commit}) {
            commit("setAuthStatus", AuthStatus.UNAUTHORIZED);
            commit('setLoading', true, {root: true});
            commit('setError', null, {root: true});

            return firebase.auth().signOut()
                .then(() => {

                }).catch((error) => {
                    commit('setError', error.message, {root: true});
                }).finally(() => {
                    commit("setLoading", false, {root: true});
                });
        }
    }
}